import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17" {...props}>
    <path d="M10.414 16.487v-4.166c0-.664-.244-1.3-.68-1.768a2.238 2.238 0 0 0-1.64-.733c-.614 0-1.204.264-1.64.733a2.602 2.602 0 0 0-.679 1.767v4.167H1.91c-.41 0-.803-.175-1.093-.488a1.735 1.735 0 0 1-.453-1.179V5.764c0-.288.07-.57.2-.821.132-.25.322-.46.55-.608l6.186-4c.24-.156.515-.238.796-.238.28 0 .555.082.795.238l6.186 4c.229.148.418.357.55.608.131.25.2.533.2.82v9.057c0 .442-.163.866-.453 1.179-.29.312-.683.488-1.093.488h-3.866Z" />
  </svg>
);
export default SvgComponent;
